import React from "react";
import { PageContent, PageRoot } from "../common";

export function HomePage() {
  return (
    <PageRoot>
      <PageContent>
        <div>This is a home page.</div>
      </PageContent>
    </PageRoot>
  );
}
